import { apiFetch } from './api';
import { useAuthStore } from '../store/useAuthStore';

// Configurable dashboard — per-user layout persistence (mirrors
// backend/src/lib/dashboardLayout.ts). The layout travels as a versioned JSON
// blob; `null` means "no saved layout, use the default".

export type WidthPreset = 2 | 3 | 4 | 6 | 8 | 12;

export interface LayoutWidget {
  id: string;
  w: WidthPreset;
}

export interface DashboardLayoutV1 {
  version: 1;
  widgets: LayoutWidget[];
}

// Standard success envelope: { success: true, data: <T> }.
interface Envelope<T> {
  success: true;
  data: T;
}

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getDashboardLayout(): Promise<DashboardLayoutV1 | null> {
  const res = await apiFetch<Envelope<DashboardLayoutV1 | null>>('/api/dashboard/layout', {
    headers: authHeaders(),
  });
  return res.data;
}

export async function putDashboardLayout(layout: DashboardLayoutV1): Promise<DashboardLayoutV1> {
  const res = await apiFetch<Envelope<DashboardLayoutV1>>('/api/dashboard/layout', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(layout),
  });
  return res.data;
}

export async function deleteDashboardLayout(): Promise<void> {
  await apiFetch<Envelope<null>>('/api/dashboard/layout', {
    method: 'DELETE',
    headers: authHeaders(),
  });
}
